<template>
  <div class="mb-3 " v-if="!isSuccess || !isClicked">
    <div class="payment-info">
      <h5 class="payment-header">Payment Info</h5>
    <div id="card-container" class="m-2"></div>
    <button id="card-button" type="submit" class="btn btn-warning d-block mx-auto mb-2 w-50" @click="this.$emit('submit',email,password,firstName,lastName)">Finish & Pay</button>
    </div>
  </div>
<div class="mb-3  text-start" v-else>
    <div id="card-container"></div>
 <i class="bi bi-hand-thumbs-up-fill"></i>
 <h5>Hooray! You're payment was successful!</h5>
</div>
</template>

<script>
export default{
    name:"LoginForm",
    data(){
        return{
        email:"",
        password:"",
        firstName:"",
        lastName:"",
        isSuccess:false,
        isClicked:false,
        }
    },
    async mounted(){
        const payments = window.Square.payments("sandbox-sq0idb-iudY97DKM7OWdol4pWJREg", "LZ7SQTMK9DV6E");
  const card = await payments.card();
  await card.attach("#card-container");
  document.getElementById("card-button").addEventListener("click", async () => {
    const result = await card.tokenize();
    if (result.status === "OK") {
      this.isClicked = true
      this.isSuccess = true
    const response = await fetch('https://store-front-backend-chi.vercel.app/api',
      {method: 'GET',
  mode: 'cors'}
    );
const text = await response.text();
console.log(text);
      // send result.token to your backend
    //   fetch('/process-payment', {
    //     method: 'POST',
    //     body: JSON.stringify({ token: result.token }),
    //     headers: { 'Content-Type': 'application/json' }
    //   });
    }
  });
    }
}
</script>

<style scoped>
.payment-info{
border-style: solid;
    border-color: orange;
    border-width: 4px;
    border-radius: 12px;
    overflow-y: scroll;
}
.payment-header{
    background-color: orange;
    color: white;
}
</style>